import React, { useEffect, useState } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import Sidebar from "../../../../../partials/aside/Sidebar";
import helperSpinner from "../../../../../../helpers/spinner";
import httpService from "../../../../../../services/httpServices/httpServices";
import helpersNumber from "../../../../../../helpers/numbers";
import helpersTime from "../../../../../../helpers/time";
import StatusCampaignSimple from "../../../banner/StatusCampaignSimple";

export default function InfoCampaign() {
  const [campaign, setCampaing] = useState();
  const params = useParams();
  const campaignID = parseInt(params.id);
  const history = useHistory();

  useEffect(() => {
    getCampaingBannerAlternative();
  }, []);

  const getCampaingBannerAlternative = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const campaing = await sendRequestGetCampaingBannerAlternative(campaignID);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!campaing) {
      return;
    }
    setCampaing(campaing);
  };

  const sendRequestGetCampaingBannerAlternative = async (
    campaingBannerAlternativeID
  ) => {
    const headersRequest = getHeaderForRequest();
    let campaing;
    try {
      campaing = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/campaign/manage/banner/alternative/" +
          campaingBannerAlternativeID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
    return campaing.data.data;
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const disableCampaing = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultSendRequestDisableCampaing = await sendRequestDisableCampaing(
      campaignID
    );
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!resultSendRequestDisableCampaing) {
      return;
    }
    history.push("/campaigns/manage/banner-alternative/all");
  };

  const sendRequestDisableCampaing = async (campaignID) => {
    const headersRequest = getHeaderForRequest();
    try {
      await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/campaign/manage/banner/alternative/" +
          campaignID +
          "/disable",
        headersRequest
      );
      return true;
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
  };

  const changeStateCampaign = async (campaignID, newState) => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultSendRequestChangeStateCampaign =
      await sendRequestChangeStateCampaign(campaignID, newState + "");
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!resultSendRequestChangeStateCampaign) {
      return;
    }
    history.push("/campaigns/manage/banner-alternative/all");
  };

  const sendRequestChangeStateCampaign = async (campaignID, newState) => {
    const headersRequest = getHeaderForRequest();
    try {
      await httpService.putRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/campaign/manage/banner/simple/change-state/" +
          campaignID,
        {
          new_state: newState,
        },
        headersRequest
      );
      return true;
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
  };

  const generateButtonsChangeStateCampaigns = (campaignStatus) => {
    let buttonsTags;
    switch (campaignStatus) {
      case StatusCampaignSimple.statusCampaign.PENDING_TO_START_DATE:
        buttonsTags = (
          <>
            <div>
              <span>حالت فعلی کمپین</span>
              <span className="px-2">:</span>
              <b>
                {
                  StatusCampaignSimple.statusCampaignString()[
                    campaign.cam_status
                  ]
                }
              </b>
            </div>
            <p className="py-2">
              برای تغییر حالت کمپین رو یکی از دکمه های زیر کلیک کنید
            </p>
            <span className="px-2">
              <button
                className="btn btn-success"
                onClick={(e) => {
                  e.preventDefault();
                  changeStateCampaign(
                    campaignID,
                    StatusCampaignSimple.statusCampaign.ACTIVE
                  );
                }}
              >
                {
                  StatusCampaignSimple.statusCampaignString()[
                    StatusCampaignSimple.statusCampaign.ACTIVE
                  ]
                }
              </button>
            </span>

            <span className="px-2">
              <button
                className="btn btn-danger"
                onClick={(e) => {
                  e.preventDefault();
                  changeStateCampaign(
                    campaignID,
                    StatusCampaignSimple.statusCampaign.CANCELED
                  );
                }}
              >
                {
                  StatusCampaignSimple.statusCampaignString()[
                    StatusCampaignSimple.statusCampaign.CANCELED
                  ]
                }
              </button>
            </span>
          </>
        );
        break;
      case StatusCampaignSimple.statusCampaign.ACTIVE:
        buttonsTags = (
          <>
            <div>
              <span>حالت فعلی کمپین</span>
              <span className="px-2">:</span>
              <b>
                {
                  StatusCampaignSimple.statusCampaignString()[
                    campaign.cam_status
                  ]
                }
              </b>
            </div>
            <p className="py-2">
              برای تغییر حالت کمپین رو یکی از دکمه های زیر کلیک کنید
            </p>
            <span className="px-2">
              <button
                className="btn btn-info"
                onClick={(e) => {
                  e.preventDefault();
                  changeStateCampaign(
                    campaignID,
                    StatusCampaignSimple.statusCampaign.FINISHED
                  );
                }}
              >
                {
                  StatusCampaignSimple.statusCampaignString()[
                    StatusCampaignSimple.statusCampaign.FINISHED
                  ]
                }
              </button>
            </span>

            <span className="px-2">
              <button
                className="btn btn-danger"
                onClick={(e) => {
                  e.preventDefault();
                  changeStateCampaign(
                    campaignID,
                    StatusCampaignSimple.statusCampaign.CANCELED
                  );
                }}
              >
                {
                  StatusCampaignSimple.statusCampaignString()[
                    StatusCampaignSimple.statusCampaign.CANCELED
                  ]
                }
              </button>
            </span>
          </>
        );
        break;
    }
    return buttonsTags;
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1  bg-warning">
                  کمپین های جایگزین بنری
                </h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div className="card-body">
              {campaign && (
                <>
                  <div className="alert alert-info">
                    <div className="py-2">
                      <span>نام کمپین</span>
                      <span className="px-2">:</span>
                      <span>{helpersNumber.toPersianNum(campaign.cam_id)}</span>
                    </div>
                    <div className="py-2">
                      <span>نام کمپین</span>
                      <span className="px-2">:</span>
                      <span>{campaign.cam_name}</span>
                    </div>

                    <div className="py-2">
                      <span>شماره گروه نمایش دهنده</span>
                      <span className="px-2">:</span>
                      <span>
                        <span className="px-2">
                          {helpersNumber.toPersianNum(campaign.cam_category_id)}
                        </span>
                        <Link
                          target="_blank"
                          to={`/manage/category-user-site-publishers/${campaign.cam_category_id}`}
                        >
                          <span className="btn btn-primary">
                            نمایش گروه نمایش دهنده بنری
                          </span>
                        </Link>
                      </span>
                    </div>

                    <div className="py-2">
                      <span>تاریخ شروع</span>
                      <span className="px-2">:</span>
                      <span className="number-finance">
                        {helpersNumber.toPersianNum(
                          "00:00 " +
                            helpersTime.convertGregorianToJalali(
                              campaign.campaign_start_date
                            )
                        )}
                      </span>
                    </div>

                    <div className="py-2">
                      <span>تاریخ پایان</span>
                      <span className="px-2">:</span>
                      <span className="number-finance">
                        {helpersNumber.toPersianNum(
                          "23:59 " +
                            helpersTime.convertGregorianToJalali(
                              campaign.campaign_end_date
                            )
                        )}
                      </span>
                    </div>

                    <div className="py-2">
                      <span>تاریخ درج</span>
                      <span className="px-2">:</span>
                      <span className="number-finance">
                        {helpersNumber.toPersianNum(
                          campaign.cam_created_at.split(" ")[1] +
                            " " +
                            helpersTime.convertGregorianToJalali(
                              campaign.cam_created_at
                            )
                        )}
                      </span>
                    </div>

                    <div className="py-2">
                      <span>مقدار فعلی</span>
                      <span className="px-2">:</span>
                      <span className="number-finance">
                        {campaign.campaign_amount == undefined
                          ? helpersNumber.toPersianNum(0)
                          : helpersNumber.toPersianNum(
                              helpersNumber.addCommaToSeparateGroupThreeNumber(
                                campaign.campaign_amount
                              )
                            )}
                      </span>
                      <span className="pr-2">تومان</span>
                    </div>
                  </div>
                  <div className="alert alert-warning">
                    <p>قبل از تغییر حالت کمپین به حالت فعلی کمپین توجه کنید.</p>
                    <p className="text-danger">
                      نکته خیلی مهم : حتما بعد از تغییر حالت کمپین به حالت مورد
                      نظر به{" "}
                      <Link
                        className="px-2 d-inline-block"
                        target={"_blank"}
                        to="/manage/publishers/check-position-campaign"
                      >
                        صفحه
                      </Link>
                      بروید و شماره کمپین را وارد کنید و جایگاه های کمپین را
                      بروز رسانی کنید
                    </p>
                    <p>
                      تغییر حالت کمپین از حالت لغو شده و تمام شده به حالت های
                      دیگر به خاطر زمان رزور شدن جایگاه توسط کاربران دیگر
                      امکانپذیر نیست.
                    </p>
                    <p>
                      تغییر حالت کمپین از هر حالتی به حالت در حال انتظار به خاطر
                      زمان رزور شدن جایگاه توسط کاربران دیگر امکانپذیر نیست.
                    </p>
                  </div>
                  <div>
                    {generateButtonsChangeStateCampaigns(campaign.cam_status)}
                  </div>
                </>
              )}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
